import type { ExperimentPersonaBinding } from '../types/vuser';

export function isPersonaAlreadyAssigned(
  pairs: ExperimentPersonaBinding[],
  virtualUserId: string,
  personaId: string
): boolean {
  return pairs.some((p) => p.virtual_user_id === virtualUserId && p.persona_id === personaId);
}

export function getDuplicatePersonaBindingMessage(bindings: ExperimentPersonaBinding[]): string | null {
  const seen = new Set<string>();
  for (const binding of bindings) {
    if (!binding.virtual_user_id || !binding.persona_id) continue;
    const key = `${binding.virtual_user_id}:${binding.persona_id}`;
    if (seen.has(key)) {
      return 'Each persona can only be assigned once per virtual user. Remove duplicate pairs.';
    }
    seen.add(key);
  }
  return null;
}
